
import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './Cookie.module.css';
import { useIntl } from "react-intl";
import { useCookies } from 'react-cookie';

const cookieID = 'DEA_COOKIE_CONSENT';

export const Cookie = ({
    history
}) => {
    const [cookies, setCookie] = useCookies([cookieID]);

    const intl = useIntl();
    const { formatMessage } = intl;

    const navigateToPrivacy = () => {
        history.push("/privacy");
    };

    const acceptPrivacy = () => {
        setCookie(cookieID, true, { path: '/' });
    };

    const closeCookieBanner = () => {
        setCookie(cookieID, false, { path: '/' });
    }

    // Render nothing if the cookie is set.
    if (cookies.hasOwnProperty(cookieID)) {
        return null;
    }

    return (
        <div className={`fixed-bottom py-3 px-5 d-flex justify-content-center ${styles.cookieContainer}`}>
            <div
                className={`position-absolute m-2 ${styles.closeIcon}`}
                onClick={closeCookieBanner}
            />
            <div className="row">
                <div className="col-12 text-center px-0 px-md-5">
                    <span className={`${styles.cookieLabel}`}>
                        { formatMessage({ id: 'cookieComponent.messageCookie' }) }
                    </span>
                </div>
                <div className="col-12 text-center mt-3">
                    <div className="row justify-content-center">
                        <div className="co-12 col-md-6 text-center text-md-right mb-2 mb-md-0">
                            <Button
                                className={`text-white rounded-pill py-1 ${styles.cookieActionButton}`}
                                onClick={() => { navigateToPrivacy() }}
                            >
                                { formatMessage({ id: 'cookieComponent.privacyPolicy' }) }
                            </Button>
                        </div>
                        <div className="co-12 col-md-6 text-center text-md-left">
                            <Button 
                                className={`text-white rounded-pill py-1 ${styles.cookieActionButton}`}
                                onClick={() => { acceptPrivacy() }}
                            >
                                { formatMessage({ id: 'cookieComponent.accetta' }) }
                            </Button>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
